import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/id';
import { toast } from 'react-toastify';

function InboundIntegrationForm({ props = {} }) {


  const [appData, setAppData] = useState({ active: true })

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const retrieveData = async () => {
 
    await axios.get(`${window.API_HOST}/v1/integration-log-inbound/${props.uid}`).then(async (res) => {
      const resp = res.data

      const data = resp.data
       setAppData(data)

    }).catch(err => {
      toast.error(err.response.data.error)
    })

    console.log(appData)

  }
  useEffect(() => {


    if (props?.uid) {
      retrieveData()
    }

  }, []);

  return (
    <div>
      <Panel>
        <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
          <div className='row'>
            <div className='col-sm-6 fw-bolder fs-2 text-black'>View Outbound Integration Log</div>
            <div className='col-sm-6 align-items-baseline text-end'>
              <div className=''> 
                {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
              </div>

            </div>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-4'>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Date Time</label>
                <div className="col-sm-9">
                  <div className='col-sm-'>
                    <input type="text" name="code" value={appData.created_at ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Shipment No</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.shipment_no ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                </div>
              </div> 
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Txn Type</label>
                <div className="col-sm-9">
                  <div className='col-sm-12'>
                    <input type="text" name="code" value={appData.txn_type ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                  </div>
                </div>
              </div> 
              <div className="form-group row mt-1">
                <label className="col-sm-3 col-form-label">Updated By </label>
                <div className="col-sm-9">
                  <input type="text" value={appData.updated_at ?? ''} className="form-control form-control-sm" readOnly disabled />
                </div> 
              </div>
            </div>
            <div className='col-sm-4'>
              
              
              
            </div>
            <div className='col-sm-4'>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Client Name</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.client_name ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Request Method</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.request_method ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">IP</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.ip_address ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">URL</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.url ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                </div>
              </div> 
            </div>
          </div>

          <div className='row mt-3'>
            <div className='col-sm-12'>
              <Tabs>
                <TabList>
                  <Tab>Request</Tab>
                  <Tab>Response</Tab>
                </TabList>
                <TabPanel>
                  <div className='row'> 
                    <div className='col-sm-12'>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="form-group h-600px" >
                            <label>Request Header</label>
                            <JSONInput
                              className='w-600px'
                              id='requestHeader'
                              name="requestHeader"
                              placeholder={appData?.request_header ?? {}}
                              value={appData?.request_header ?? {}}
                              onChange={() => { }}
                              colors={{
                                background: "rgba(182,194,201,.1)",
                                default: "black",
                                keys: "red"
                              }}
                              theme={"light_mitsuketa_tribute"}
                              locale={locale}
                              onKeyPressUpdate={false}
                              waitAfterKeyPress={1300}
                              width={'auto'}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="form-group">
                            <label>Request Body</label>
                            <JSONInput
                              id='requestBody'
                              name="requestBody"
                              placeholder={appData?.request_body ?? {}}
                              value={appData?.request_body ?? {}}
                              onChange={() => { }}
                              colors={{
                                background: "rgba(182,194,201,.1)",
                                default: "black",
                                keys: "red"
                              }}
                              theme={"light_mitsuketa_tribute"}
                              locale={locale}
                              onKeyPressUpdate={false}
                              waitAfterKeyPress={1300}
                              width={'auto'}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className='row'>
                    <div className='col-sm-4'>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Response Status</label>
                        <div className="col-sm-9">
                          <div className='col-sm-'>
                            <input type="text" name="code" value={appData.response_status ?? ''} onChange={() => { }} className="form-control form-control-sm" readOnly={true} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-12'>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="form-group">
                            <label>Response Header</label>
                            <JSONInput
                              id='responseHeader'
                              name="responseHeader"
                              placeholder={appData?.response_header ?? {}}
                              value={appData?.response_header ?? {}}
                              onChange={() => { }}
                              colors={{
                                background: "rgba(182,194,201,.1)",
                                default: "black",
                                keys: "red"
                              }}
                              theme={"light_mitsuketa_tribute"}
                              locale={locale}
                              onKeyPressUpdate={false}
                              waitAfterKeyPress={1300}
                              width={'auto'}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="form-group">
                            <label>Response Body</label>
                            <JSONInput
                              id='responseBody'
                              name="responseBody"
                              placeholder={appData?.response_body ?? {}}
                              value={appData?.response_body ?? {}}
                              onChange={() => { }}
                              colors={{
                                background: "rgba(182,194,201,.1)",
                                default: "black",
                                keys: "red"
                              }}
                              theme={"light_mitsuketa_tribute"}
                              locale={locale}
                              onKeyPressUpdate={false}
                              waitAfterKeyPress={1300}
                              width={'auto'}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </PanelBody>
      </Panel>
    </div>

  )


}

export default InboundIntegrationForm